/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { WithStyles, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import * as moment from "moment";
import * as React from "react";

import { Customer } from "../../types/Customer";
import { Form } from "../../types/Form";
import { ProductName } from "../../types/Products";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import { required } from "../../validators";
import InputDate from "../InputDate/InputDate";
import { calculatorPopinFormStyles } from "./CalculatorPopinForm.styles";

interface CalculatorPopinFormCustomerProps extends WithStyles<typeof calculatorPopinFormStyles> {
    productName: ProductName;
    customer: Customer;
    onChange(customer: Customer, isCustomerModifiedOrNew?: boolean);
}

type CalculatorPopinFormCustomerState = {
    form: Form<Customer>;
};

class CalculatorPopinFormCustomer extends React.Component<
    CalculatorPopinFormCustomerProps,
    CalculatorPopinFormCustomerState
> {
    private formBuilder = null;

    componentWillMount() {
        this.updateState(this.props);
    }

    componentWillReceiveProps(nextProps: CalculatorPopinFormCustomerProps) {
        this.updateState(nextProps);
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values, true);
    }

    public render() {
        if (!this.state) return null;

        const uiForm = this.formBuilder.build(this.state.form);

        return (
            <div className={this.props.classes.box}>
                <Typography variant={"headline"} gutterBottom={true} className={this.props.classes.formTitle}>
                    Age de l'adhérent
                </Typography>
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={4}>
                        <InputDate {...uiForm.fields.birthdate} />
                    </Grid>
                </Grid>
            </div>
        );
    }

    private getMaxDateForProduct(productName: ProductName) {
        if (productName === "GPI")
            return moment()
                .subtract(18, "year")
                .date(31)
                .month(11)
                .format("YYYY-MM-DD");
        return moment()
            .subtract(18, "year")
            .format("YYYY-MM-DD");
    }

    private updateState(props: CalculatorPopinFormCustomerProps) {
        this.formBuilder = new UiFormBuilder<Customer>()
            .addField("birthdate", {
                props: {
                    label: "Date de naissance",
                    required: true,
                    dateProps: {
                        min: moment()
                            .subtract(100, "year")
                            .format("YYYY-MM-DD"),
                        max: this.getMaxDateForProduct(this.props.productName),
                    },
                },
            })
            .onChange(this.onChange.bind(this));

        this.setState({
            form: {
                fields: {},
                errors: [],
                values: props.customer || {},
            },
        });
    }
}

export default CalculatorPopinFormCustomer;



// WEBPACK FOOTER //
// ./src/components/Calculator/CalculatorPopinFormCustomer.tsx